import { firebase } from "@firebase/app";
import "@firebase/firestore";
import "@firebase/messaging";
import "@firebase/auth";

firebase.initializeApp({
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGGING_SENDER_ID
});
  
// Initialize Cloud Firestore through Firebase
const dbInstance = firebase.firestore();
// Retrieve Firebase Messaging object.
const messaging = firebase.messaging();
  
// Disable deprecated features
dbInstance.settings({
    timestampsInSnapshots: true
});

export const db = dbInstance;
export const fb =  firebase;
export const fcm = messaging;
